import { useState, useEffect } from "react";
import { Close, DisplayFlex, ModalEditar, ModalServiceClassification, Rodape, ModalOverlay, ModalForcarFolha, ButtonConfirmForcar } from "./styled";
import { CiSquareRemove, CiTrash, CiEdit, CiRepeat, CiFileOn } from "react-icons/ci";
import { BsFileText } from "react-icons/bs";
import { ButtonBlue, ButtonBlueService, ColumnTitle, CustomButton, TableBody, TableColumn, TableContainer, TableHead, TableHeader, TableRow } from "../../../../CSSGlobal";
import axios from "axios";
import { Input, Modal, Skeleton, Spin, Switch, Alert, Button, Tooltip } from "antd";
import { LoadingOutlined, PlusOutlined} from '@ant-design/icons';
import { toast } from "react-toastify";
import { Box, LinearProgress } from "@mui/material";
import { formatValueBrl2 } from "../../../../function/utilis/function";

export function ClassificacaoServicos({setModalServicos}) {
    useEffect(()=>{
        fetchData();
       
    },[])

    const [listTitle]=useState([
        "CNAE",
        "Código Municipal",
        "Código Federal",
        "RFB Serviço",
        "Anexo / Fator R",
        "RFB Anexos",
        "Editar",
        "Remover"
    ]);

    const [data, setData]=useState([
    ]);

    const [info, setInfo] = useState({
        id: "",
        cnae: "",
        descricao: "",
        codigoServicoMunicipal: "",
        codigoServicoFederal: "",
        rfbServicoFederal: "",
        anexo: "",
        fatorR: false,
        rfbAnexo: "",
        rfbFatorR: false,
    })

    const [forcedObject, setForcedObject] = useState({
        valor: "",
        cpp: "",
        checkForcado: false,
    })

    const [errorBox, setErrorBox] = useState({
        message: "",
        description: "",
        type: "info",
    })

    const [isMessageError, setIsMessageError]=useState(true)

    const [isModalEditar, setIsModalEditar]=useState(false)

    const [loadingModalEditar, setLoadingModalEditar]=useState(false)

    const [loadingList, setLoadingList]=useState(false)

    const [isModalOpen, setIsModalOpen] = useState(false)

    const [isModalForcarFolha, setIsModalForcarFolha] = useState(false)

    const [validaInput, setValidaInput] = useState({cnae: '', anexo: '', codigoServicoFederal: ''})

    const fecharModal = () => {
        setModalServicos(false);
    };

    const onChange = (checked) => {
        console.log(`switch to ${checked}`);
        setInfo(prevState => ({
            ...prevState,
            fatorR: checked
        }));
    };

    const onChangeForcado = (checked) => {
        console.log(`switch to ${checked}`);
        setForcedObject(prevState => ({
            ...prevState,
            checkForcado: checked
        }));
    };

    const closeModalEditar = () => {
        setIsModalEditar(false);
        setValidaInput((prevState) => ({
            ...prevState,
            cnae: '',
            anexo: '',
            codigoServicoFederal: ''
        }));
    };

    const closeModalForcarFolha = () => {
        setIsModalForcarFolha(false);
    };

    const openModalEditar = (value) => {
        console.log(value);
        setErrorBox((prevState) => ({
            ...prevState,
            message: "EDITAR",
            description: "Preencha os campos disponiveis de acordo com a alteração desejada.",
            type: "info"
        }));
        setIsModalEditar(true);
        setInfo(value);
    }

    const openModalForcarFolha = () => {
        setErrorBox((prevState) => ({
            ...prevState,
            message: "FORÇAR FOLHA ANTERIOR",
            description: "Ao selecionar 'Valor Forçado', o sistema usará o valor fixo da folha para o cálculo do Anexo 5, ignorando o valor apurado automaticamente pela rotina. Escolha com atenção.",
            type: "info"
        }));
        setIsModalForcarFolha(true);
    }

    const openModalCadastrar = () => {
        console.log(data)
        setErrorBox((prevState) => ({
            ...prevState,
            message: "Cadastrar",
            description: "Preencha os campos disponiveis para realizar o cadastro.",
            type: "info"
        }));
        setIsModalEditar(true);
        setInfo(data);
    }

    const showModaRemover = (value) => {
        setIsModalOpen(true);
        setInfo(value);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
      setIsModalOpen(false);
    };

    const sincService = async () => {
        const url = '/portal/rest/contador/empresa/faturamento/servico/sincronizar'

        const payload = {}
        try {
            setLoadingList(true)
            const response = await axios.post(url, payload, {withCredentials: true})

            if(response.status === 204){
                toast.success("Sincronização efetuada com sucesso!")
                fetchData()
            }else{
                toast.error("Ocorreu um erro ao tentar sincronizar.")
            }
        } catch (error) {
            toast.error("Ocorreu um erro interno.")
        }finally{
            setLoadingList(false)
        }


    };

    const fetchData = async () => {
        const url = '/portal/rest/contador/empresa/faturamento/servico/listar'
        setLoadingList(true)

        try {
            const response = await axios.post(url, {})

            const dataResponse = response.data

            setData(dataResponse)

           setInfo({ 
            id: dataResponse.id,
            cnae: dataResponse.cnae,
            descricao: dataResponse.descricao,
            codigoServicoMunicipal: dataResponse.codigoServicoMunicipal === null || dataResponse.codigoServicoMunicipal === "" ? "campo vazio" : dataResponse.codigoServicoMunicipal,
            codigoServicoFederal: dataResponse.codigoServicoFederal === null || dataResponse.codigoServicoFederal === "" ? "campo vazio" : dataResponse.codigoServicoFederal,
            rfbServicoFederal: dataResponse.rfbServicoFederal === null || dataResponse.rfbServicoFederal === "" ? "campo vazio" : dataResponse.rfbServicoFederal,
            anexo: dataResponse.anexo === null || dataResponse.anexo === "" ? "campo vazio" : dataResponse.anexo,
            fatorR: dataResponse.fatorR,
            rfbAnexo: dataResponse.rfbAnexo === null || dataResponse.rfbAnexo === "" ? "campo vazio" : dataResponse.rfbAnexo,
            rfbFatorR: dataResponse.rfbFatorR,
        });
        } catch (error) {
            
        }finally{
            setLoadingList(false)
        }
    } 

    const deleteData = async () => {
        const url = '/portal/rest/contador/empresa/faturamento/servico/remover'

        const payload = {id:info.id}
        try {
            const response = await axios.post(url, payload, {withCredentials: true})

            if(response.status === 204){
                handleOk()
                toast.success("Remoção efetuada com sucesso!")
                fetchData()
            }else{
                toast.error("Ocorreu um erro ao tentar remover.")
            }
        } catch (error) {
            toast.error("Ocorreu um erro interno.")
        }finally{
            setLoadingModalEditar(false)
        }
    }

    const insertData = async () => {
        let url = '/portal/rest/contador/empresa/faturamento/servico/cadastrar';
        let payload = {
            anexo: info.anexo || '',
            cnae: info.cnae || '',
            codigoServicoFederal: info.codigoServicoFederal || '',
            codigoServicoMunicipal: info.codigoServicoMunicipal || '',
            fatorR: info.fatorR || false,
            id: info.id || ''
        };
    
        try {
            setLoadingModalEditar(true);
            
            if (!info.cnae && !info.codigoServicoMunicipal && !info.codigoServicoFederal) {
                setErrorBox((prevState) => ({
                    ...prevState,
                    message: "Campos obrigatórios",
                    description: "Pelo menos um dos campos (CNAE, Código de Serviço Municipal ou Federal) é obrigatório.",
                    type: "error"
                }));
                setIsMessageError(true)
                setValidaInput((prevState) => ({
                    ...prevState,
                    cnae: 'error',
                    anexo: 'error',
                    codigoServicoFederal: 'error'
                }));
            } else if (info.cnae && info.cnae.length < 7) {
                setErrorBox((prevState) => ({
                    ...prevState,
                    message: "O campo CNAE está incompleto",
                    description: "Preencha o CNAE com pelo menos 7 caracteres.",
                    type: "error"
                }));
                setValidaInput((prevState) => ({
                    ...prevState,
                    cnae: 'error'
                }));
            } else if (!info.anexo) {
                setErrorBox((prevState) => ({
                    ...prevState,
                    message: "O campo anexo é obrigatório.",
                    description: "O campo ANEXO precisa ter um valor indicado.",
                    type: "error"
                }));
                setValidaInput((prevState) => ({
                    ...prevState,
                    anexo: 'error'
                }));
            } else if(info.anexo.includes(' ') || info.anexo.includes(',') || info.anexo.includes('-') || info.anexo.includes('_') || info.anexo.includes('.')){
                setErrorBox((prevState) => ({
                    ...prevState,
                    message: "É permitido apenas 1 anexo.",
                    description: "O campo ANEXO não pode ter mais de um valor nele.",
                    type: "error"
                }));
                setValidaInput((prevState) => ({
                    ...prevState,
                    anexo: 'error'
                }));
            } else {
                const response = await axios.post(url, payload, { withCredentials: true });
                if (response.status === 204 || response.status === 200) {
                    if(response.request.response.includes("erro")){
                        setErrorBox((prevState) => ({
                            ...prevState,
                            message: "Dados informados são inválidos.",
                            description: "Um dos campos está com o valor inválido para realizar a confirmação.",
                            type: "error"
                        }));
                        setValidaInput((prevState) => ({
                            ...prevState,
                            cnae: 'error',
                            anexo: 'error',
                            codigoServicoFederal: 'error'
                        }));
                    }else{
                        setIsModalEditar(false);
                        toast.success("Cadastro realizado com sucesso!");
                        setValidaInput((prevState) => ({
                            ...prevState,
                            cnae: '',
                            anexo: '',
                            codigoServicoFederal: ''
                        }));
                        fetchData();
                    }
                } else {
                    toast.error("Ocorreu um erro ao tentar completar a ação.");
                }
            }
        } catch (error) {
            toast.error("Ocorreu um erro interno.");
        } finally {
            setLoadingModalEditar(false);
        }
    }

    const updateData = async () => {
        let url = '/portal/rest/contador/empresa/faturamento/servico/atualizar';
        let payload = {
            anexo: info.anexo,
            cnae: info.cnae,
            codigoServicoFederal: info.codigoServicoFederal,
            codigoServicoMunicipal: info.codigoServicoMunicipal,
            fatorR: info.fatorR,
            id: info.id
        };
    
        try {
            console.log(payload)
            setLoadingModalEditar(true);

            if (!info.cnae && !info.codigoServicoMunicipal && !info.codigoServicoFederal) {
                setErrorBox((prevState) => ({
                    ...prevState,
                    message: "Campos obrigatórios",
                    description: "Pelo menos um dos campos (CNAE, Código de Serviço Municipal ou Federal) é obrigatório.",
                    type: "error"
                }));
                setIsMessageError(true)
                setValidaInput((prevState) => ({
                    ...prevState,
                    cnae: 'error',
                    anexo: 'error',
                    codigoServicoFederal: 'error'
                }));
            } else if (info.cnae && info.cnae.length < 7) {
                setErrorBox((prevState) => ({
                    ...prevState,
                    message: "O campo CNAE está incompleto",
                    description: "Preencha o CNAE com pelo menos 7 caracteres.",
                    type: "error"
                }));
                setValidaInput((prevState) => ({
                    ...prevState,
                    cnae: 'error'
                }));
            } else if (!info.anexo) {
                setErrorBox((prevState) => ({
                    ...prevState,
                    message: "O campo anexo é obrigatório.",
                    description: "O campo ANEXO precisa ter um valor indicado.",
                    type: "error"
                }));
                setValidaInput((prevState) => ({
                    ...prevState,
                    anexo: 'error'
                }));
            } else if(info.anexo.includes(' ') || info.anexo.includes(',') || info.anexo.includes('-') || info.anexo.includes('_') || info.anexo.includes('.')){
                setErrorBox((prevState) => ({
                    ...prevState,
                    message: "É permitido apenas 1 anexo.",
                    description: "O campo ANEXO não pode ter mais de um valor nele.",
                    type: "error"
                }));
                setValidaInput((prevState) => ({
                    ...prevState,
                    anexo: 'error'
                }));
            } else {
                const response = await axios.post(url, payload, { withCredentials: true });
                if (response.status === 204 || response.status === 200) {
                    if(response.request.response.includes("erro")){
                        setErrorBox((prevState) => ({
                            ...prevState,
                            message: "Dados informados são inválidos.",
                            description: "Um dos campos está com o valor inválido para realizar a confirmação.",
                            type: "error"
                        }));
                        setValidaInput((prevState) => ({
                            ...prevState,
                            cnae: 'error',
                            anexo: 'error',
                            codigoServicoFederal: 'error'
                        }));
                    }else{
                        setIsModalEditar(false);
                        toast.success('Edição efetuada com sucesso!');
                        setValidaInput((prevState) => ({
                            ...prevState,
                            cnae: '',
                            anexo: '',
                            codigoServicoFederal: ''
                        }));
                        fetchData();
                    }
                }else {
                    toast.error("Ocorreu um erro ao tentar completar a ação.");
                }
            }
        } catch (error) {
            toast.error("Ocorreu um erro interno.");
        } finally {
            setLoadingModalEditar(false);
        }
    }

    const forcedApi = async () => {
        let url = '/portal/rest/fiscal/nf/forcedFolha';
        let result = forcedObject.valor.replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", ".");
        let payload = {
            "valor" : result,
            //"cpp" : forcedObject.cpp,
            "valorForcado" : forcedObject.checkForcado
        };

        try{
            const response = await axios.post(url, payload);

            if(response.status === 204 || response.status === 200){
                handleOk()
                toast.success("Folha adicionada com sucesso!")
                fetchData()
                setIsModalForcarFolha(false)
            }else{
                toast.error("Ocorreu um erro ao tentar adicionar a folha.")
            }

        }catch(erro){
            toast.error("Ocorreu um erro interno.")
        }finally{
            console.log("Aqui vai um load")
        }
    }

    return (
        <ModalServiceClassification>
            <DisplayFlex>
                <Close>
                    <CiSquareRemove
                        className="font-icon"
                        onClick={fecharModal}
                    />
                </Close>
            </DisplayFlex>
            <DisplayFlex style={{display: 'flex', gap: '10px', justifyContent: 'right', alignItems: 'center', position: 'relative', right: '25px'}}>
                <ButtonBlueService onClick={() => sincService()}><CiRepeat />Sincronizar serviços</ButtonBlueService>
                <ButtonBlueService onClick={() => openModalForcarFolha()}><CiFileOn />Forçar folha anterior</ButtonBlueService>
                <Tooltip title="Adicionar">
                  <CustomButton type="primary" shape="circle" icon={<PlusOutlined />} onClick={() => openModalCadastrar()} />
                </Tooltip>
            </DisplayFlex>
            <div>
                <TableHeader>
                    <TableHead>
                        {listTitle.map((titulo,index)=>{
                            return(
                                <ColumnTitle key={index}>
                                    <strong style={{color: "#005a9e", fontSize: 12}}>{titulo}</strong>
                                </ColumnTitle>
                            )
                        })}
                    </TableHead>
                </TableHeader>

                    
                    {loadingList && (
                        <Box sx={{ width: "100%" }}>
                            <LinearProgress />
                      </Box>
                    )}

                    {loadingList ? (
                        <>
                        {[...Array(8)].map((_, index) => (
                          <Skeleton
                            key={index}
                            variant="rectangular"
                            width="100%"
                            height={40}
                          />
                        ))}
                      </>
                    ): (
                        <TableContainer>
                            <TableBody>
                                {data.length > 0 ? (
                                    data.map((item, index) => (
                                        <>
                                            <div style={{border:"1px solid #d5d5d5", margin: 5, padding: 14, borderRadius: 4}}>
                                                <TableRow key={index}>
                                                    <TableColumn>
                                                        <ColumnTitle>{item.cnae ? item.cnae : "N/A"}</ColumnTitle>
                                                        <ColumnTitle>{item.codigoServicoMunicipal ? item.codigoServicoMunicipal : "N/A"}</ColumnTitle>
                                                        <ColumnTitle>{item.codigoServicoFederal ? item.codigoServicoFederal : "N/A"}</ColumnTitle>
                                                        <ColumnTitle>{item.rfbServicoFederal ? item.rfbServicoFederal : "N/A"}</ColumnTitle>
                                                        <ColumnTitle>{item.anexo ? item.anexo : "N/A"} - {item.fatorR === false ? "Não" : "Sim"}</ColumnTitle>
                                                        <ColumnTitle>{item.rfbAnexo ? item.rfbAnexo : "N/A"} - {item.rfbFatorR === false ? "Não" : "Sim"}</ColumnTitle>
                                                        <ColumnTitle>
                                                            <div style={{ margin: "0 5px" }}>
                                                                <CustomButton type="primary" onClick={() => openModalEditar(item)}><CiEdit /> Editar</CustomButton>
                                                            </div>
                                                            <div>
                                                                <Button type="primary" danger onClick={() => showModaRemover(item)}><CiTrash /> Remover</Button>
                                                            </div>
                                                        </ColumnTitle>
                                                    </TableColumn>
                                                </TableRow>
                                                <div style={{margin:"12px 0px"}}>
                                                    <div style={{textAlign:"left"}}>
                                                        <span style={{color: "#4e4e4e"}}>
                                                            <strong><BsFileText style={{fontSize: 16}}/> Atividade referente ao CNAE {item.cnae ? item.cnae : "N/A"} :</strong> {item.descricao ? item.descricao : "N/A"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ))
                                ) : (
                                    <Alert message="Não há informações" type="info" showIcon />
                                )}
                            </TableBody>
                        </TableContainer>
                    )}
           
               
              
            </div>
            {isModalForcarFolha && (<>
                <ModalOverlay />
                <ModalForcarFolha>
                    <Close>
                        <CiSquareRemove
                            className="font-icon"
                            onClick={closeModalForcarFolha}
                        />
                    </Close>
                        {isMessageError && (<>
                            <div style={{marginBottom: 10}}><strong>Forçar Folha Anterior</strong></div>
                            <div>
                                <Alert description={errorBox.description} />
                            </div>
                        </>)}
                        <DisplayFlex>
                            <div className="margin-10">
                                <div>
                                    <div className="title-input">
                                        <span>Valor</span>
                                    </div>
                                    <Input
                                        status={forcedObject.valor === 'error' ? "error" : ""}
                                        placeholder="Digite o valor da folha"
                                        style={{ width: 230 }}
                                        value={forcedObject.valor} // Mostra o valor formatado
                                        onChange={(event) => {
                                            let inputValue = event.target.value;

                                            // Remove caracteres inválidos e formata em tempo real
                                            const formattedValue = formatValueBrl2(inputValue);

                                            // Atualiza o estado com o valor formatado
                                            setForcedObject((prevState) => ({
                                            ...prevState,
                                            valor: formattedValue,
                                            }));
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="margin-10">
                                <div>
                                    <div className="title-input">
                                        <span>CPP</span>
                                    </div>
                                        <Input 
                                            status={forcedObject.cpp === 'error' ? "error" : ""}
                                            placeholder={forcedObject.cpp}
                                            style={{ width: 230 }} 
                                            value={forcedObject.cpp} 
                                            onChange={(event) => {
                                                setForcedObject((prevState) => ({
                                                    ...prevState,
                                                    cpp: event.target.value,
                                                }));
                                            }}
                                        />
                                </div>
                            </div>
                        </DisplayFlex>
                        <DisplayFlex>
                            <div className="margin-10">
                                <div>
                                    <span>Valor forçado</span>
                                    <br/>
                                    <div className="switch">
                                        <Switch 
                                            checked={forcedObject.checkForcado}
                                            onChange={onChangeForcado}
                                        />
                                    </div>
                                </div>
                            </div>
                        </DisplayFlex>
                    <Rodape>
                        <CustomButton onClick={forcedApi}>Confirmar</CustomButton>
                    </Rodape>
                </ModalForcarFolha>
            </>)}
            {isModalEditar && (<>
                <ModalOverlay />
                <ModalEditar>
                    <Close>
                        <CiSquareRemove
                            className="font-icon"
                            onClick={closeModalEditar}
                        />
                    </Close>
                    <div>
                        {isMessageError && (<>
                            <Alert
                                message={errorBox.message}
                                description={errorBox.description}
                                type={errorBox.type}
                            />
                        </>)}
                        <DisplayFlex>
                            <div className="margin-10">
                                <div>
                                    <div className="title-input">
                                        <span>ID</span>
                                    </div>
                                        <Input 
                                            placeholder={info.id} 
                                            style={{ width: 230 }} 
                                            value={info.id} 
                                            disabled 
                                        />
                                </div>
                            </div>
                            <div className="margin-10">
                                <div>
                                    <div className="title-input">
                                        <span>Cnae</span>
                                    </div>
                                    <Input 
                                        status={validaInput.cnae === 'error' ? "error" : ""}
                                        placeholder={info.cnae}
                                        style={{width:230}}
                                        value={info.cnae}
                                        onChange={(event) => {
                                            setInfo((prevState) => ({
                                              ...prevState,
                                              cnae: event.target.value,
                                            }));
                                         }}
                                    />
                                </div>
                            </div>
                        </DisplayFlex>
                        <DisplayFlex>
                            <div className="margin-10">
                                <div>
                                    <div className="title-input">
                                        <span>Atividade</span>
                                    </div>
                                    <Input 
                                        placeholder={info.descricao} 
                                        style={{width:480}}
                                        value={info.descricao}
                                        onChange={(event) => {
                                            setInfo((prevState) => ({
                                              ...prevState,
                                              descricao: event.target.value,
                                            }));
                                         }}
                                        disabled
                                    />
                                </div>
                            </div>
                        </DisplayFlex>
                        <DisplayFlex>
                            <div className="margin-10">
                                <div>
                                    <div className="title-input">
                                        <span>Código Municipal</span>
                                    </div>
                                    <Input 
                                        placeholder={info.codigoServicoMunicipal} 
                                        style={{width:230}}
                                        value={info.codigoServicoMunicipal}
                                        onChange={(event) => {
                                            setInfo((prevState) => ({
                                              ...prevState,
                                              codigoServicoMunicipal: event.target.value,
                                            }));
                                         }}
                                    />
                                </div>
                            </div>
                            <div className="margin-10">
                                <div>
                                    <div className="title-input">
                                        <span>Código Federal</span>
                                    </div>
                                    <Input 
                                        status={validaInput.codigoServicoFederal === 'error' ? "error" : ""}
                                        placeholder={info.codigoServicoFederal}
                                        style={{width:230}}
                                        value={info.codigoServicoFederal}
                                        onChange={(event) => {
                                            setInfo((prevState) => ({
                                              ...prevState,
                                              codigoServicoFederal: event.target.value,
                                            }));
                                         }}
                                    />
                                </div>
                            </div>
                        </DisplayFlex>
                        <DisplayFlex>
                            <div className="margin-10">
                                <div>
                                    <div className="title-input">
                                        <span>RFB Serviço</span>
                                    </div>
                                    <Input
                                        placeholder={info.rfbServicoFederal}
                                        style={{width:230}}
                                        value={info.rfbServicoFederal}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="margin-10">
                                <div>
                                    <div className="title-input">
                                        <span>Anexo</span>
                                    </div>
                                    <Input
                                        status={validaInput.anexo === 'error' ? "error" : ""}
                                        placeholder={info.anexo}
                                        style={{width:230}}
                                        value={info.anexo}
                                        onChange={(event) => {
                                            setInfo((prevState) => ({
                                              ...prevState,
                                              anexo: event.target.value,
                                            }));
                                         }}
                                    />
                                </div>
                            </div>
                        </DisplayFlex>
                        <DisplayFlex>
                            <div className="margin-10">
                                <div>
                                    <div className="title-input">
                                        <span>RFB Anexos</span>
                                    </div>
                                    <Input
                                    placeholder={info.rfbAnexo}
                                    style={{width:230}}
                                    value={info.rfbAnexo}
                                    disabled
                                    />
                                </div>
                            </div>
                            <div className="margin-10">
                                <div>
                                    <span>Fator R</span>
                                    <br/>
                                    <div className="switch">
                                        <Switch 
                                            checked={info.fatorR}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </DisplayFlex>
                    </div>
                    <div className="loading">
                        {data?(
                            loadingModalEditar && (
                            <Spin
                                indicator={
                                <LoadingOutlined
                                    style={{
                                    fontSize: 48,
                                    }}
                                    spin
                                />
                                }
                            />
                        )):(<></>)}
                    </div>

                    <Rodape>
                        <CustomButton style={{width: 100, margin: "0 auto"}}
                            onClick={() => {   
                                if(info.id != null){
                                    updateData()
                                }else{
                                    insertData()
                                }
                            }}>Salvar</CustomButton>
                    </Rodape>
                </ModalEditar></>
            )}
            <Modal title="Remover" open={isModalOpen} onOk={deleteData} onCancel={handleCancel} okText='Sim' cancelText='Não'>
                <p>Deseja remover a classificação de serviço {info.cnae}?</p>
            </Modal>
        </ModalServiceClassification>
    );
}

export default ClassificacaoServicos;